<div
  class="sidebar-pool"
  [ngClass]="{
    mobile: (isMobile$ | async),
    tablet: (isTablet$ | async)
  }"
>
  <mat-nav-list>
    <a class="item-select" [ngClass]="{ 'wm-select--no-border': (isMobile$ | async) === false }">
      <mat-form-field appearance="outline" class="wm-select wm-select--small">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 4.35418C12.7329 3.52375 13.8053 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C13.8053 11 12.7329 10.4762 12 9.64582M15 21H3V20C3 16.6863 5.68629 14 9 14C12.3137 14 15 16.6863 15 20V21ZM15 21H21V20C21 16.6863 18.3137 14 15 14C13.9071 14 12.8825 14.2922 12 14.8027M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
            stroke="#848484"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <mat-select #farmSelect formControlName="type" panelClass="wm-select-panelClass" (selectionChange)="onChangeFarm($event.value)" [value]="selectedFarm?.id">
          @for (account of accounts; track account) {
          <mat-option [value]="account.id">
            {{ account.label || account.account }}
          </mat-option>
          }

          <div class="create-farm cursor-pointer create-farm-option" (click)="createFarm()">
            <span class="create-farm-option-label">
              {{ 'WM_TECH_MMS.MENU.CREATE_FARM' | translate }}
            </span>
            <svg _ngcontent-serverApp-c297="" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
              <path
                _ngcontent-serverApp-c297=""
                d="M15.478,13.349a13.423,13.423,0,0,0,5.418-1.1,14.428,14.428,0,0,0,4.465-3.029A14.181,14.181,0,0,0,28.39,4.76,13.5,13.5,0,0,0,29.485-.658a13.389,13.389,0,0,0-1.1-5.4,14.367,14.367,0,0,0-3.036-4.465,14.266,14.266,0,0,0-4.465-3.029,13.463,13.463,0,0,0-5.4-1.095,13.463,13.463,0,0,0-5.4,1.095,14.266,14.266,0,0,0-4.465,3.029A14.266,14.266,0,0,0,2.58-6.062a13.463,13.463,0,0,0-1.095,5.4,13.423,13.423,0,0,0,1.1,5.418A14.341,14.341,0,0,0,5.616,9.218a14.341,14.341,0,0,0,4.458,3.029A13.389,13.389,0,0,0,15.478,13.349Zm0-3a10.766,10.766,0,0,1-4.273-.853A11.037,11.037,0,0,1,7.7,7.134,10.94,10.94,0,0,1,5.346,3.629,10.88,10.88,0,0,1,4.5-.658a10.844,10.844,0,0,1,.846-4.273A10.94,10.94,0,0,1,7.7-8.437,11.059,11.059,0,0,1,11.2-10.8a10.75,10.75,0,0,1,4.28-.853,10.75,10.75,0,0,1,4.28.853,11.144,11.144,0,0,1,3.505,2.361,10.979,10.979,0,0,1,2.368,3.505,10.766,10.766,0,0,1,.853,4.273,10.555,10.555,0,0,1-.846,4.287,11.2,11.2,0,0,1-2.361,3.505,10.954,10.954,0,0,1-3.5,2.361A10.837,10.837,0,0,1,15.478,10.348ZM10.586.678h9.8A1.277,1.277,0,0,0,21.337.3a1.3,1.3,0,0,0,.37-.946,1.332,1.332,0,0,0-.37-.974A1.277,1.277,0,0,0,20.384-2h-9.8a1.3,1.3,0,0,0-.96.377,1.318,1.318,0,0,0-.377.974A1.283,1.283,0,0,0,9.627.3,1.3,1.3,0,0,0,10.586.678ZM15.464,5.57a1.332,1.332,0,0,0,.974-.37,1.277,1.277,0,0,0,.377-.953v-9.8a1.294,1.294,0,0,0-.377-.967,1.332,1.332,0,0,0-.974-.37,1.253,1.253,0,0,0-.946.377,1.328,1.328,0,0,0-.363.96v9.8a1.3,1.3,0,0,0,.363.953A1.266,1.266,0,0,0,15.464,5.57Z"
                transform="translate(-1.485 14.651)"
                fill="#74FE74"
              ></path>
            </svg>
          </div>
        </mat-select>
      </mat-form-field>
    </a>

    <a mat-list-item routerLink="/account" routerLinkActive="active" (click)="centerItem()" [ngClass]="{ border: (isMobile$ | async), borderBtn: (isMobile$ | async) }">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 12H19M5 12C3.89543 12 3 11.1046 3 10V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V10C21 11.1046 20.1046 12 19 12M5 12C3.89543 12 3 12.8954 3 14V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V14C21 12.8954 20.1046 12 19 12M17 8H17.01M17 16H17.01"
          stroke="#848484"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      {{ 'WM_TECH_POOL.D.MENU.ACCOUNT' | translate }}
    </a>
    <a
      mat-list-item
      [routerLink]="!tabDisabled ? '/statistics' : null"
      routerLinkActive="active"
      (click)="centerItem()"
      [disabled]="tabDisabled"
      [ngClass]="{ border: (isMobile$ | async), borderBtn: (isMobile$ | async) }"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 13V12M12 13V10M16 13V8M8 21L12 17L16 21M3 4H21M4 4H20V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V4Z"
          stroke="#848484"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      {{ 'WM_TECH_POOL.D.MENU.STATISTICS' | translate }}
    </a>
    <a
      mat-list-item
      [routerLink]="!tabDisabled ? '/workers' : null"
      routerLinkActive="active"
      (click)="centerItem()"
      [disabled]="tabDisabled"
      [ngClass]="{ border: (isMobile$ | async), borderBtn: (isMobile$ | async) }"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 7V5" stroke="#848484" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
        <path d="M15 7V5" stroke="#848484" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
        <path d="M9 11H6" stroke="#848484" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
        <path d="M19 11H15" stroke="#848484" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
        <path
          d="M19.4104 10.6137C19.4082 8.59517 18.6769 6.65995 17.3769 5.23261C16.0768 3.80526 14.3142 3.00235 12.4757 3C10.6372 3.00235 8.87454 3.80526 7.57451 5.23261C6.27447 6.65995 5.54317 8.59517 5.54103 10.6137C5.31644 10.6126 5.09436 10.6656 4.89048 10.769C4.6866 10.8725 4.5059 11.0238 4.36114 11.2123C4.21638 11.4008 4.11109 11.622 4.05272 11.8601C3.99434 12.0982 3.98431 12.3475 4.02332 12.5903C4.10045 12.9951 4.30407 13.3576 4.59892 13.6149C4.89378 13.8723 5.26131 14.0084 5.63791 13.9996H19.3619C19.7385 14.0084 20.106 13.8723 20.4009 13.6149C20.6958 13.3576 20.8994 12.9951 20.9765 12.5903C21.0164 12.343 21.0054 12.089 20.9443 11.8469C20.8832 11.6049 20.7735 11.3809 20.6234 11.1914C20.4732 11.0019 20.2863 10.8516 20.0765 10.7517C19.8666 10.6517 19.639 10.6046 19.4104 10.6137Z"
          stroke="#848484"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M6 14.0405H19V14.8507C18.9888 16.4853 18.299 18.0493 17.0812 19.2014C15.8634 20.3535 14.2166 21 12.5 21C10.7761 21 9.12279 20.3479 7.90381 19.187C6.68482 18.0262 6 16.4518 6 14.8102V14V14.0405Z"
          stroke="#848484"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </svg>

      {{ 'WM_TECH_POOL.D.MENU.WORKERS' | translate }}
    </a>
    <a
      mat-list-item
      [routerLink]="!tabDisabled ? '/payouts' : null"
      routerLinkActive="active"
      (click)="centerItem()"
      [disabled]="tabDisabled"
      [ngClass]="{ border: (isMobile$ | async), borderBtn: (isMobile$ | async) }"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 8C10.3431 8 9 8.89543 9 10C9 11.1046 10.3431 12 12 12C13.6569 12 15 12.8954 15 14C15 15.1046 13.6569 16 12 16M12 8C13.1104 8 14.0799 8.4022 14.5987 9M12 8V7M12 8L12 16M12 16L12 17M12 16C10.8896 16 9.92008 15.5978 9.40137 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
          stroke="#848484"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      {{ 'WM_TECH_POOL.D.MENU.PAYOUTS' | translate }}
    </a>
    <a
      mat-list-item
      [routerLink]="!tabDisabled ? '/rewards' : null"
      routerLinkActive="active"
      (click)="centerItem()"
      [disabled]="tabDisabled"
      [ngClass]="{ border: (isMobile$ | async), borderBtn: (isMobile$ | async) }"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 7H21M21 7V15M21 7L13 15L9 11L3 17" stroke="#848484" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      {{ 'WM_TECH_POOL.D.MENU.REWARDS' | translate }}
    </a>
    <a mat-list-item (click)="openConnect()" [disabled]="tabDisabled" [ngClass]="{ border: (isMobile$ | async), borderBtn: (isMobile$ | async) }">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15 7C16.1046 7 17 7.89543 17 9M21 9C21 12.3137 18.3137 15 15 15C14.3938 15 13.8087 14.9101 13.2571 14.7429L11 17H9V19H7V21H4C3.44772 21 3 20.5523 3 20V17.4142C3 17.149 3.10536 16.8946 3.29289 16.7071L9.25707 10.7429C9.08989 10.1914 9 9.60617 9 9C9 5.68629 11.6863 3 15 3C18.3137 3 21 5.68629 21 9Z"
          stroke="#848484"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      {{ 'WM_TECH_POOL.D.MENU.CONNECT' | translate }}
    </a>
    <a
      mat-list-item
      [routerLink]="!tabDisabled ? '/settings' : null"
      routerLinkActive="active"
      (click)="centerItem()"
      [disabled]="tabDisabled"
      [ngClass]="{ border: (isMobile$ | async), borderBtn: (isMobile$ | async) }"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.3246 4.31731C10.751 2.5609 13.249 2.5609 13.6754 4.31731C13.9508 5.45193 15.2507 5.99038 16.2478 5.38285C17.7913 4.44239 19.5576 6.2087 18.6172 7.75218C18.0096 8.74925 18.5481 10.0492 19.6827 10.3246C21.4391 10.751 21.4391 13.249 19.6827 13.6754C18.5481 13.9508 18.0096 15.2507 18.6172 16.2478C19.5576 17.7913 17.7913 19.5576 16.2478 18.6172C15.2507 18.0096 13.9508 18.5481 13.6754 19.6827C13.249 21.4391 10.751 21.4391 10.3246 19.6827C10.0492 18.5481 8.74926 18.0096 7.75219 18.6172C6.2087 19.5576 4.44239 17.7913 5.38285 16.2478C5.99038 15.2507 5.45193 13.9508 4.31731 13.6754C2.5609 13.249 2.5609 10.751 4.31731 10.3246C5.45193 10.0492 5.99037 8.74926 5.38285 7.75218C4.44239 6.2087 6.2087 4.44239 7.75219 5.38285C8.74926 5.99037 10.0492 5.45193 10.3246 4.31731Z"
          stroke="#848484"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
          stroke="#848484"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      {{ 'WM_TECH_POOL.D.MENU.SETTINGS' | translate }}
    </a>
  </mat-nav-list>

  <div class="balance-mobile">
    <wm-libs-balance-block *ngIf="(isMobile$ | async) === true" [balance]="balance"></wm-libs-balance-block>
  </div>
</div>
